export default "__VITE_ASSET__Xq7C8DV1__"